import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M8.28809 12L14.2981 18.01L15.7121 16.596L11.1121 11.996L15.7121 7.39599L14.2981 5.98999L8.28809 12Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "ChevronLeft"
);
